/*
 * @Author: jiansuiwang@rastar.com
 * @Date: 2023-11-08 17:09:56
 * @LastEditors: jiansuiwang@rastar.com
 * @LastEditTime: 2023-11-15 18:00:13
 * @FilePath: \sea-page-game\src\utils\initFaceBookSdk.js
 */
import Base from "./base";

// 根据appid 动态引入facebook sdk script
const urlData = Base.parseUrl(window.location.href); // canshu

let appid = "581319757190728";
if (urlData.appid == "103321") {
  appid = "1045052619962688";
} else if (urlData.appid == "104293") {
  appid = "323463700245106";
}
var script = document.createElement("script");
script.src =
  "https://connect.facebook.net/zh_TW/sdk.js#xfbml=1&version=v3.3&appId=" +
  appid +
  "&autoLogAppEvents=1";
script.defer = true;
script.async = true;
script.crossOrigin = "anonymous";
document.head.appendChild(script);
